import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

const ACTION_OBJECT_NAME = 'WRITING_ASSIGNMENT';
export const PUBLISH_WRITING_ASSIGNMENT_REQUEST = `PUBLISH_${ACTION_OBJECT_NAME}_REQUEST`;
export const PUBLISH_WRITING_ASSIGNMENT_SUCCESS = `PUBLISH_${ACTION_OBJECT_NAME}_SUCCESS`;
export const PUBLISH_WRITING_ASSIGNMENT_FAILURE = `PUBLISH_${ACTION_OBJECT_NAME}_FAILURE`;

export const publishWritingAssignmment = (id, payload) => (dispatch) => {
  const url = buildUrl(`/writing-assignment-activities/${id}/publish`);
  const method = 'POST';
  return dispatch(publishWritingAssignmmentRequest()).payload
    .then((response) => dispatch(publishWritingAssignmmentSuccess(response)))
    .catch((error) => dispatch(publishWritingAssignmmentFailure(error)));

  function publishWritingAssignmmentRequest() {
    const request = fetch(url,
      {
        method,
        body: JSON.stringify(payload),
      }
    );
    return ApiCall.createAction({
      type: PUBLISH_WRITING_ASSIGNMENT_REQUEST,
      payload: request,
      url,
      method,
    });
  }

  function publishWritingAssignmmentSuccess() {
    return ApiCall.createAction({
      type: PUBLISH_WRITING_ASSIGNMENT_SUCCESS,
      url,
      method,
    });
  }

  function publishWritingAssignmmentFailure(error) {
    return ApiCall.createAction({
      type: PUBLISH_WRITING_ASSIGNMENT_FAILURE,
      url,
      method,
      error,
    });
  }
};



// WEBPACK FOOTER //
// ./data/WritingAssignment/Activity/actions.js